import { defineComponent, nextTick, onMounted, ref } from "vue";
import Utils from "../../utils/Utils";
import UploadInfoBar from "../../components/UploadInfoBar";
import Offers from "../../components/Offers";
import { OfferJson } from "../../OrderForm";
import OfferUtils from "../../utils/OfferUtils";

export default defineComponent({
    components: {
        Offers,
        UploadInfoBar,
    },

    template: `
        <div class="StepInvoiceReco">
            <div class="wrapper wrapper--1104">
                <h1 class="title-1">Rekomendowana taryfa</h1>

                <UploadInfoBar
                    :options="options"
                    @change="$emit('invoice:change')"
                />

                <hr>
            </div>

            <div class="StepInvoiceReco__body">
                <Offers
                    v-if="offers"
                    :offers="offers"

                    :allasfeatured="true"

                    @offer:click="onOfferClick"
                />
            </div>

            <div class="StepInvoiceReco__more">
                <button type="button" class="button button--secondary" @click="$emit('more:click')">Zobacz pozostałe oferty</button>
            </div>
        </div>
    `,

    emits: [
        'offer:select',
        'invoice:change',
        'more:click',
    ],

    props: {
        options: { type: Object, required: true },
        offer: { type: Object, required: true },
    },

    setup(props, ctx) {
        const offers = ref(null as OfferJson[]);

        async function reload() {
            offers.value = await OfferUtils.fetchOffers(props.offer.tariff);
        }

        async function onOfferClick(offer: OfferJson) {
            await Utils.setCart('offer', {
                offer_id: offer.id,
            });

            ctx.emit('offer:select', offer);
        }

        onMounted(() => {
            reload();

            nextTick(() => {
                Utils.scrollToEl($('.StepInvoiceReco'));
            });
        });

        return {
            offers,

            onOfferClick,
        }
    },
});
